import { cloneElement, memo, useMemo, useRef, useState } from "react";
import { parseTextWithLinks } from "../../../utils/helper";
import { Tooltip } from "../../UI";
import ModuleIcon from "../ModuleIcon";
import {
  StyledBookmarkContainer,
  StyledModuleBox,
  StyledModuleBoxBody,
  StyledModuleDescriptionContainer,
  StyledModuleTitle,
} from "../Modules-styled";

const Bookmark = ({ ...props }) => {
  return (
    <svg
      stroke="currentColor"
      fill="currentColor"
      strokeWidth="0"
      viewBox="0 0 512 512"
      height="16px"
      width="16px"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="32"
        d="M352 48H160a48 48 0 0 0-48 48v368l144-128 144 128V96a48 48 0 0 0-48-48z"
      ></path>
    </svg>
  );
};

const ModuleBox = ({
  module,
  selectedModule,
  handleModuleClick,
  handleBookmarkClick,
  t,
}) => {
  const [textVisible, setTextVisible] = useState(false);
  const hoverTimeout = useRef();

  const handleMouseEnter = () => {
    clearTimeout(hoverTimeout.current);
    hoverTimeout.current = setTimeout(() => setTextVisible(true), 800); // 800ms delay
  };

  const handleMouseLeave = () => {
    clearTimeout(hoverTimeout.current);
    hoverTimeout.current = setTimeout(() => {
      setTextVisible(false);
    }, 400);
  };

  const renderParsedTitle = (arr) =>
    arr.map((part, idx) => {
      if (typeof part === "object" && part.type === "a") {
        // Clone the element and add your custom onClick
        return cloneElement(part, {
          key: idx,
          onClick: (e) => {
            e.stopPropagation();
            // ...your custom logic here if needed
          },
        });
      } else if (typeof part === "string") {
        // Detect <a ...>...</a> as a string (basic detection)
        const aTagMatch = part.match(/^<a.*?href=['"](.*?)['"].*?>(.*?)<\/a>$/);
        if (aTagMatch) {
          const href = aTagMatch[1];
          const text = aTagMatch[2];
          return (
            <a
              key={idx}
              href={href}
              target="_blank"
              rel="noreferrer"
              onClick={(e) => {
                e.stopPropagation();
              }}
            >
              {text}
            </a>
          );
        }
      }
      return part;
    });

  const processedTitle = useMemo(() => {
    const arr = parseTextWithLinks(module.title);
    // return renderParsedTitle(arr);
    return arr;
  }, [module.title]);

  const handleTitleClick = (e) => {
    // If the clicked element is an <a> tag
    if (e.target.tagName === "A") {
      e.stopPropagation();
      return;
    }
  };
  return (
    <StyledModuleBox
      color={module.color}
      onClick={handleModuleClick}
      key={module.moduleName}
    >
      <StyledModuleTitle>{module.moduleName}</StyledModuleTitle>
      <StyledModuleBoxBody>
        <StyledModuleDescriptionContainer
          onMouseEnter={handleMouseEnter}
          onMouseLeave={handleMouseLeave}
        >
          <span
            onClick={handleTitleClick}
            style={{ position: "relative", display: "block" }}
          >
            {processedTitle}
            <Tooltip
              visible={textVisible}
              content={
                <span
                  onClick={(e) => {
                    e.stopPropagation();
                  }}
                >
                  {processedTitle}
                </span>
              }
              showOnHover
              placement="bottom"
              blurred
              zIndex={21}
              absolute
            />
          </span>
        </StyledModuleDescriptionContainer>
        <StyledBookmarkContainer onClick={handleBookmarkClick}>
          <Tooltip
            content={t("screen.widget.ModuleSwitcher.bookmarkTooltip")}
            showOnHover
            placement="top"
            blurred
            zIndex={21}
          >
            <Bookmark
              fill={module.module === selectedModule ? "#fff" : module.color}
              className="bookmark"
            />
          </Tooltip>
        </StyledBookmarkContainer>
        <ModuleIcon
          className="module-icon-holder"
          opsColor={module.color}
          module={module.module}
        />
      </StyledModuleBoxBody>
    </StyledModuleBox>
  );
};

export default memo(ModuleBox);
